<script>import ButtonBoxWhite from "../elements/buttons/variants/ButtonBoxWhite.svelte";
import ButtonBoxPrimary from "../elements/buttons/variants/ButtonBoxPrimary.svelte";
import ButtonText from "../elements/buttons/variants/ButtonText.svelte";
import ButtonBoxTextColor from "../elements/buttons/variants/ButtonBoxTextColor.svelte";
export let color = "secondary";
export let textColor = null;
export let size = "default";
export let items = [];
export let appearance = "button";
let props = {
  size,
  hrefTarget: "blank",
  classNames: "flex-shrink-0"
};
$: textColor && (props = { ...props, textColor });
</script>

{#each items as item}
	{#if appearance === 'button'}
		{#if color === 'white'}
			<ButtonBoxWhite props={{ ...props, href: item.url, iconLeft: item.iconName }} />
		{:else if color === 'primary'}
			<ButtonBoxPrimary props={{ ...props, href: item.url, iconLeft: item.iconName }} />
		{:else}
			<ButtonBoxTextColor props={{ ...props, href: item.url, iconLeft: item.iconName }} />
		{/if}
	{:else}
		<ButtonText props={{ ...props, href: item.url, iconLeft: item.iconName }} />
	{/if}
{/each}
